import { createSlice } from "@reduxjs/toolkit";

export const areaLocationSlice = createSlice({
    name: 'arealocation',
    initialState: {
        type: "thailand",
        value: ""
    },
    reducers: {
        setAreaType: (state, action) => {
            state.type = action.payload;
            state.value = "";
        },
        setAreaValue: (state, action) => {
            state.value = action.payload;
        }
    }
})

export const { setAreaType, setAreaValue } = areaLocationSlice.actions;

export const getAreaLocation = (state) => state.arealocation;

export default areaLocationSlice.reducer;